import { FindDeliveryWindowsFilterOptionsOutput } from '../../../services/modules/filterOptions/filterOptions.types';
import { DeliveryWindow } from '../../products/ProductTypes';
import { OfflineDatabaseDeliveryWindow } from '../database/offlineDatabase/types/offlineDatabaseDeliveryWindow.types';

export class OfflineDeliveryWindowTransformers {
  static toDeliveryWindow(offlineDeliveryWindow: OfflineDatabaseDeliveryWindow): DeliveryWindow {
    return {
      id: offlineDeliveryWindow.id,
      name: offlineDeliveryWindow.name,
      code: offlineDeliveryWindow.code,
      endDate: offlineDeliveryWindow.endDate,
      startDate: offlineDeliveryWindow.startDate,
    };
  }

  static toFilterOptionsDeliveryWindow(
    data: OfflineDatabaseDeliveryWindow,
  ): FindDeliveryWindowsFilterOptionsOutput['data'][0] {
    return {
      id: data.id,
      code: data.code,
      name: data.name,
    };
  }
}
